import React from 'react';
import { getHeapAttributes } from '../../../utils/heap/heap.helper';
import { IToggleButton } from '../../../models/toggle-button/IToggleButton';
import styles from './toggle-button.module.scss';
import { replaceAttrSpaceWithHyphen } from '../../../utils/string-helpers/replace-attr-space-with-hyphen';

export default function ToggleButton({
  inputColor,
  label,
  value,
  group,
  handleOnToggle,
  handleOnClick,
  isChecked,
  heapIdentifier,
  customClass,
}: IToggleButton) {
  function changeHandler(event) {
    if (handleOnToggle) {
      handleOnToggle(event.target.dataset?.value);
    }
  }

  function clickHandler(event) {
    if (handleOnClick) {
      handleOnClick(event.target.dataset?.value);
    }
  }

  const heapAttributes =
    heapIdentifier && getHeapAttributes(heapIdentifier, { filterValue: label });

  const toggleButtonStyles = {
    '--toggle-button-input-color': inputColor,
  } as React.CSSProperties;

  return (
    <>
      <input
        className={`${styles['toggle-input']} ${styles[customClass]}`}
        type='radio'
        role='radio'
        name={group}
        id={replaceAttrSpaceWithHyphen(`radio-${group}-${label}`)}
        data-value={value}
        onChange={changeHandler}
        onClick={clickHandler}
        defaultChecked={isChecked}
        style={toggleButtonStyles}
        aria-label={label}
        {...heapAttributes}
      />
      <label
        className={`${styles['toggle-label']}`}
        htmlFor={replaceAttrSpaceWithHyphen(`radio-${group}-${label}`)}
        tabIndex={-1}
        style={toggleButtonStyles}
      >
        {label}
      </label>
    </>
  );
}
